var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _maxQueueStorage = _interopRequireDefault(require("../../../utils/maxQueueStorage"));
var AlreadyRated = (0, _maxQueueStorage["default"])('RATE-BOX', 50);
var _default = AlreadyRated;
exports["default"] = _default;